import React, { useContext } from 'react';
import { Button, makeStyles, mergeClasses } from '@fluentui/react-components';
import { Book20Regular } from '@fluentui/react-icons';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';

interface PromptBarProps {
  onViewPromptClick?: () => void;
}

const usePromptBarStyles = makeStyles({
  promptBarContainer: {
    height: '24px',
    width: '100%',
    display: 'flex',
    maxWidth: '652px',
    alignSelf: 'center',
    flexDirection: 'row',
    justifyContent: 'end',
    marginBottom: '8px',
  },
});

export const PromptBar: React.FC<PromptBarProps> = ({ onViewPromptClick }) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const styles = usePromptBarStyles();
  return (
    <div className={mergeClasses('prompt-bar-container', styles.promptBarContainer)}>
      <Button appearance="transparent" icon={<Book20Regular />} onClick={onViewPromptClick} size="small">
        {i18n.getString(_TL_('View Prompts'))}
      </Button>
    </div>
  );
};
